import { createContext } from 'react';

export const SidebarWidthMenu = createContext<any>(0);